<template>
  <transition name="app-progress">
    <div
      v-if="progress.visible"
      class="app-progress-bar"
      :class="{'app-progress-bar--failed': progress.failed}"
      role="progressbar"
      aria-label="페이지 로딩"
      :aria-busy="progress.pending > 0"
    />
  </transition>
</template>

<script>
import {progressState} from '@/plugins/progress'

export default {
  name: 'AppProgressBar',
  data() {
    return {
      progress: progressState,
    }
  },
}
</script>

<style scoped>
.app-progress-bar {
  background: rgb(127, 192, 133);
  height: 4px;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  transition: background-color 0.15s ease;
  width: 100%;
  z-index: 9999;
}

.app-progress-bar--failed {
  background: red;
}

.app-progress-enter-active,
.app-progress-leave-active {
  transition: opacity 0.2s ease;
}

.app-progress-enter-from,
.app-progress-leave-to {
  opacity: 0;
}
</style>
